<style scoped>
    @import url("../../styles/dashMain/painelDashMain.scss");
</style>

<template>
    <div class="box_painelDashMain mt-4 mb-4" v-if="!$store.state.flagMenuSup">

        <!-- Usuário -->
        <div class="linhaTit">
            <v-icon 
            :style="{'color': flagPisca ? '#1F7AB1' : ''}"
            >
                mdi-account-wrench
            </v-icon>
            <span>Bem vinda(o), {{ $store.state.contentUser.nome }}</span>
        </div>

        <div class="linhaContent mb-4">

            <!-- BTN LOG OFF USER -->
            <div class="btnLogOffUser mr-1"
            @click="closePainel()"
            @mouseover="changeBtnLogOff('on')"
            @mouseleave="changeBtnLogOff('off')"
            :style="{'background':backLogOffBtn}"
            >
                <!-- <v-icon x-large>mdi-account-lock</v-icon> -->
                <v-icon :style="{'color':corIconLogOffBtn}" x-large>mdi-door-closed-lock</v-icon>
                <span>Sair do painel</span>
            </div>

            <CardUserDashMain :objUser="$store.state.contentUser" />

        </div>

        <!-- Serviços -->
        <div class="linhaTit">
            <v-icon>mdi-calendar-cursor-outline</v-icon>
            <span>Subscrições</span>
        </div>

        <div class="linhaContent mb-4">
            
            <CardServDashMain v-for="(s, i) in liServsLocal" :key="i"
            :serv="s.serv" :img="s.img" :content="s.content" :rota="s.rota"
            />

        </div>

        <!-- Pedidos / compras -->
        <div class="linhaTit">
            <v-icon>mdi-package-variant</v-icon>
            <span>Pedidos</span>
        </div>

        <div class="linhaContent mb-4">

            <div v-if="liAllPdd.length == 0" :style="{'font-size':'0.8rem'}">Você ainda não fez nenhum pedido.</div>
            
            <PainelPddDashMain v-else :liAllPdd="liAllPdd" />

        </div>

    </div>
</template>

<script>
import axios from 'axios'

import CardUserDashMain from './CardUserDashMain'
import CardServDashMain from './CardServDashMain'

import PainelPddDashMain from './PainelPddDashMain'

export default {

    props:['objUser','cart_id','z0'],

    components:{CardUserDashMain, CardServDashMain, PainelPddDashMain},

    data() {
        return {
            //
            liServsLocal:[], // lista de serviços contratados pelo usuário. Rcv from db.

            backLogOffBtn:'rgba(1,1,1,0.6)', // background do btn logoff user.
            corIconLogOffBtn:'',

            flagPisca:false,

            liAllPdd:[],
        }
    },

    methods:{

        // -- encerrar sessão do usuário logado. (não necessário enviar parâmetro flag).
        closePainel() { this.$emit('closePainel'); localStorage.clear(); },
        
        changeBtnLogOff(strFlag) { 
            if(strFlag == 'on') {
                this.backLogOffBtn = 'rgba(31,122,177,0.4)'
                this.corIconLogOffBtn = 'rgb(247,215,46)'
            } else {
                this.backLogOffBtn = 'rgba(1,1,1,0.6)'
                this.corIconLogOffBtn = ''
            }
        },

        startPiscaUserIcon() { setInterval(() => { this.flagPisca = !this.flagPisca }, 2800) },

        getPddByEmail(email) { 
            console.log('[getPddByEmail] email: ',email)

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }
            let params = { 'email':email }
            let self = this

            const url = self.$store.state.pathAxiosBASE + '/xgetxguestcartxe' // concat
            return axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result) // list
                self.liAllPdd = res.data.result
            })
        },

        getPddByCartId(cartId) {
            // -- chamar info cartId
            console.log('cartId: ',cartId)

            const headers = {
                'Authorization': '',
                'Content-Type': 'application/json'
            }
            const payload = { 'cartId': cartId }
            const url = self.$store.state.pathAxiosBASE + '/xgetxguestcart' // concat

            axios.post(url, payload, {headers}).then(function (res) {

                // recebe {}
                console.log(res) // dict

                if (res.data.result == 'Credenciais validadas') {

                    let objUser = {
                        'nome':res.data.result.usuario.nome,
                        'email':res.data.result.usuario.email,
                        'liServs':[],
                    }

                    // -- STORAGE
                    localStorage.setItem('contentUser', JSON.stringify(objUser))

                    self.$store.state.contentUser = objUser // informações a partir do carrinho recém criado.
                    self.$store.state.flagLogadoDash = true // abrir dash vazio.
                    return

                } else {

                    self.flag_loading_loginAgro = false // desabilitar loading
                    self.flagErrorLogin = true
                    return
                }
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        this.startPiscaUserIcon()

        if (this.z0 == 'cnex') { this.getPddByCartId(this.cart_id) }
        else { this.getPddByEmail(this.$store.state.contentUser.email) }
        
        //console.log('objUser [painelDashMain]: ',this.objUser)
        let imgServGW = 'url(' + require('../../assets/gopr1.jpg') + ')'
        let imgServCA  = 'url(' + require('../../assets/countAguat0.png') + ')'
        let imgServMV = 'url(' + require('../../assets/logos/mvlogo.png') + ')'
        let imgServSC = 'url(' + require('../../assets/logos/logo-smart-control-v3.png') + ')'
        
        this.liServsLocal = this.$store.state.contentUser.liServs // pode ser []
        if (this.liServsLocal.length == 0) { this.liServsLocal = this.objUser.liServs } // qnd refresh?

        // -- temporário (imagem do card serviço dinâmica) rcv from db
        let c=0
        while (c < this.liServsLocal.length) {
            if (this.liServsLocal[c].serv == 'Gateway LoRaWAN') { this.liServsLocal[c].img = imgServGW }
            if (this.liServsLocal[c].serv == 'Contador Água') { this.liServsLocal[c].img = imgServCA }
            if (this.liServsLocal[c].serv == 'Projeto Montanha Viva') { this.liServsLocal[c].img = imgServMV }
            if (this.liServsLocal[c].serv == 'Smart Control') { this.liServsLocal[c].img = imgServSC }
            c++
        }
    }
}
</script>